import {
  Button,
  Form,
  Space,
  Modal,
  message,
  Radio,
  Typography,
  // Alert,
} from "antd";
import { useDRSContext } from "Pages/DRS/Context/DRSContext";
import DRSFooterFilter from "Pages/DRS/DRSFooterFilter";
import "./index.css";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import {
  BASE_URL,
  DRS_DOUBT_REJECT,
  DRS_DOUBT_SKIP,
  DRS_REJECT_QUESTION_REASON,
  DRS_SKIP_QUESTION_REASON,
  GET_CONFIG__BY_CONFIG_KEY,
  GET_QUESTION_DETAIL,
  REJECT_DOUBT,
  SKIP_QUESTIONS,
} from "utilFunctions/Constants/urlConstants";
import { drsEmitter } from "Pages/MyBatches/EmitterBus";
import { DRS_NEW_QUESTION } from "Pages/DRS/Constant/Constant";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import WarningModal from "Components/CommonComponents/WarningModal";
import { WarningOutlined } from "@ant-design/icons";
import {
  getAPIRequest,
  putPostRequest,
} from "utilFunctions/Axios/AxiosRequestConfiguration";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";

const { Text, Title } = Typography;
interface DRSFooterProps {
  onSave: () => void;
  tabIndex: number;
}
const DRSFooter = ({ onSave }: DRSFooterProps) => {
  const {
    updatedQuestion,
    isQuestionSessionStarted,
    fetchQuestionDetail,
    setQuestionPayload,
    setUpdatedQuestion,
    form,
    selectedQuestion,
    setSelectedQuestion,
    setAiSolutionUsed,
    getDRSSkipReasons,
    skipReason: SKIP_REASONS,
    DSRFilters,
    isSkipped,
    setIsSkipped,
    isSubmitting,
    isUploading,
  } = useDRSContext();
  const {
    facultyDailySkipCount = 0,
    maxFacultyDailySkipCount = 0,
    maxQuestionSkipCount = 0,
    questionSkipCount = 0,
    status = "",
  } = selectedQuestion || {};
  const navigate = useNavigate();
  const { screen } = useWindowSize();
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [visible, setVisible] = useState(false);
  const [skipModalVisible, setSkipModalVisible] = useState(false);
  const [skipReason, setSkipReason] = useState<string | null>(null);
  const streamIdChanged = Form.useWatch("streamId", form);
  const subjectIdChanged = Form.useWatch("subjectId", form);
  const answerTextChanged = Form.useWatch("answerText", form)?.trim().length;
  const { streamId: sId, subjectId: subId } = selectedQuestion || {};
  const { streamId, subjectId } = updatedQuestion || {};
  const isStreamChanged = streamId ? Boolean(sId != streamId) : false;
  const isSubjectChanged = subjectId ? Boolean(subId != subjectId) : false;
  const [rejectReasons, setRejectReasons] = useState<any>([]);
  const [skippedQuestionsToday, setSkippedQuestionsToday] =
    useState<boolean>(false);
  const getDRSRejectReasons = async (url: string) => {
    getAPIRequest({
      url: url,
      success: (res: any) => {
        const { data: response } = res || {};
        const { data: dataRes } = response || {};
        const { configValue } = dataRes || {};
        const arr = configValue.split(",");
        setRejectReasons(
          arr.map((ele: any) => ({
            label: ele,
            value: ele,
          }))
        );
      },
      failure: (err: any) => {
        console.log(err);
      },
    });
  };
  useEffect(() => {
    const { streamId, subjectId } = selectedQuestion || {};
    const baseDisabled = isQuestionSessionStarted
      ? updatedQuestion?.isAnswerFinal
      : false;

    const isAnyFilled =
      Boolean(streamIdChanged != streamId) ||
      Boolean(subjectIdChanged != subjectId) ||
      Boolean(answerTextChanged);
    setIsDisabled(baseDisabled || !isAnyFilled);
  }, [
    isQuestionSessionStarted,
    updatedQuestion?.isAnswerFinal,
    streamIdChanged,
    subjectIdChanged,
    answerTextChanged,
    selectedQuestion,
  ]);
  useEffect(() => {
    getDRSSkipReasons(
      BASE_URL +
        GET_CONFIG__BY_CONFIG_KEY +
        DRS_DOUBT_SKIP +
        "&configKey=" +
        DRS_SKIP_QUESTION_REASON
    );
    getDRSRejectReasons(
      BASE_URL +
        GET_CONFIG__BY_CONFIG_KEY +
        DRS_DOUBT_REJECT +
        "&configKey=" +
        DRS_REJECT_QUESTION_REASON
    );
  }, []);
  const isNext = isQuestionSessionStarted
    ? updatedQuestion?.isAnswerFinal
      ? true
      : isStreamChanged || isSubjectChanged
      ? true
      : false
    : false;
  const navigateToQuestion = () => {
    navigate("/admin/DRS", {
      state: { from: "DRS/question" },
    });
  };
  const resetStateHandler = () => {
    form.resetFields();
    setQuestionPayload((prev: any) => ({
      ...prev,
      contentRecordIds: null,
    }));
    setAiSolutionUsed(false);
    drsEmitter.emit(DRS_NEW_QUESTION, "clear");
    setUpdatedQuestion({});
  };
  const isQuestionSkipped = status === "SKIPPED";
  const handleSkip = () => {
    if (!skipReason) return;

    const payload: any = {
      questionId: selectedQuestion?.id,
      skipReason: skipReason,
    };
    if (isQuestionSkipped) {
      payload["remarks"] = skipReason;
      delete payload.skipReason;
    }
    const url =
      status == "SKIPPED" ? BASE_URL + REJECT_DOUBT : BASE_URL + SKIP_QUESTIONS;
    putPostRequest({
      url: url,
      method: "post",
      body: payload,
      success: (res: any) => {
        console.log("Skip Response:", res);
        setSkipModalVisible(false);
        setSkipReason(null);
        message.success(
          `Doubt ${
            isQuestionSkipped ? "rejected" : "skipped"
          } successfully, next doubt fetched`
        );
        setSkippedQuestionsToday(false);
        setIsSkipped(true);
        // Update selectedQuestion to reflect the new status immediately
        setSelectedQuestion((prev: any) => ({
          ...prev,
          status: isQuestionSkipped ? "REJECTED" : "SKIPPED",
          ...(isQuestionSkipped
            ? { skippedBy: null, skippedReason: null, skippedByEmail: null }
            : {}),
        }));
        resetStateHandler();
      },
      failure: (err: any) => {
        message.error(
          err?.detailMessage ||
            err?.message ||
            `Failed to ${isQuestionSkipped ? "reject" : "skip"} the doubt`
        );
        console.log(err);
      },
    } as any);
  };
  const callClaimAPI = () => {
    let newURL = BASE_URL + GET_QUESTION_DETAIL + "?";
    const filters2: any = [];
    const formFilters = { ...DSRFilters };
    delete formFilters["dateRange"];
    const formValues: any = removeEmptyFields(formFilters);
    for (const key in formValues) {
      if (Object.prototype.hasOwnProperty.call(formValues, key)) {
        if (formValues[key] != null && formValues[key] != "") {
          filters2.push(
            encodeURIComponent(key) + "=" + encodeURIComponent(formValues[key])
          );
        }
      }
    }
    if (Array.isArray(filters2) && filters2.length > 0) {
      newURL = newURL + "&" + filters2.join("&");
    }
    fetchQuestionDetail(newURL);
  };
  const REASONS = status === "SKIPPED" ? rejectReasons : SKIP_REASONS;
  return (
    <div
      className={
        ["xxl", "xl", "lg"].includes(screen)
          ? isQuestionSessionStarted
            ? "attendanceCardFooter pl-7"
            : "attendanceCardFooter justify-content-end"
          : `drs-footer ${isQuestionSessionStarted ? "with-filter" : ""}`
      }
      style={{
        backgroundColor: "#ffffff",
        borderTop: "1px solid #f0f0f0",
        display: "flex",
        flexWrap: "wrap",
        gap: ["xs", "sm", "md"].includes(screen) ? "8px" : "16px",
        padding: ["xs", "sm", "md"].includes(screen) ? "8px 12px" : "12px 24px",
      }}
    >
      <Modal
        title={
          <div>
            <Title level={4} style={{ marginBottom: 0 }}>
              {isQuestionSkipped ? "Reject Question" : "Skip Question"}
            </Title>
            <Text type="secondary">
              You can only {isQuestionSkipped ? "reject" : "skip"}{" "}
              {maxFacultyDailySkipCount} questions/day
            </Text>
          </div>
        }
        open={skipModalVisible}
        onOk={handleSkip}
        onCancel={() => {
          setSkipModalVisible(false);
          setSkipReason(null);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setSkipModalVisible(false);
              setSkipReason(null);
            }}
            style={{ borderRadius: "6px", fontWeight: 500 }}
          >
            Cancel
          </Button>,
          <Button key="skip" danger onClick={handleSkip} disabled={!skipReason}>
            {isQuestionSkipped ? "Reject Question" : "Skip Question"}
          </Button>,
        ]}
        width={500}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {/* <Alert
            message={`${
              isQuestionSkipped ? "Rejecting" : "Skipping"
            } this question. Please note it and revise the related concepts for future questions.`}
            type="info"
            showIcon
            icon={<InfoCircleOutlined />}
            style={{
              backgroundColor: "#e6f7ff",
              border: "1px solid #91d5ff",
              borderRadius: "8px",
              color: "#0050b3",
            }}
          /> */}

          {/* <div
            style={{
              border: "1px solid #f0f0f0",
              borderRadius: "8px",
              padding: "16px",
            }}
          >
            <Text strong style={{ display: "block", marginBottom: "12px" }}>
              Difficulty <span style={{ color: "#ff4d4f" }}>*</span>
            </Text>
            <Radio.Group
              onChange={(e) => setDifficulty(e.target.value)}
              value={difficulty}
              style={{ display: "flex", flexDirection: "column", gap: "8px" }}
            >
              {SKIP_DIFFICULTY_LIST.map((item: any) => (
                <Radio key={item.value} value={item.value}>
                  {item.label}
                </Radio>
              ))}
            </Radio.Group>
          </div> */}

          <div
            style={{
              border: "1px solid #f0f0f0",
              borderRadius: "8px",
              padding: "16px",
            }}
          >
            <Text strong style={{ display: "block", marginBottom: "12px" }}>
              Reason <span style={{ color: "#ff4d4f" }}>*</span>
            </Text>
            <Radio.Group
              onChange={(e) => setSkipReason(e.target.value)}
              value={skipReason}
              style={{ display: "flex", flexDirection: "column", gap: "8px" }}
            >
              {REASONS.map((item: any) => (
                <Radio key={item.value} value={item.value}>
                  {item.label}
                </Radio>
              ))}
            </Radio.Group>
          </div>
        </div>
      </Modal>

      <WarningModal
        visible={visible}
        setVisible={setVisible}
        warningMessage={"Are you sure want to end the session?"}
        iconComponent={
          <WarningOutlined
            style={{ fontSize: 48, color: "#faad14", marginBottom: 16 }}
          />
        }
        okText="Ok"
        onCancel={() => {
          setVisible(false);
        }}
        onConfirm={() => {
          navigateToQuestion();
          setVisible(false);
          resetStateHandler();
        }}
      ></WarningModal>
      <div
        className="d-flex flex-grow-1"
        style={{
          minWidth: ["xs", "sm", "md"].includes(screen) ? "100%" : "auto",
        }}
      >
        {isQuestionSessionStarted && <DRSFooterFilter></DRSFooterFilter>}
      </div>

      <Space
        size={["xs", "sm", "md"].includes(screen) ? 4 : 8}
        style={{
          width: ["xs", "sm", "md"].includes(screen) ? "100%" : "auto",
          justifyContent: ["xs", "sm", "md"].includes(screen)
            ? "space-between"
            : "flex-end",
        }}
      >
        {isNext ? (
          <Space size={["xs", "sm"].includes(screen) ? 4 : 8}>
            <Button
              size={["xs", "sm"].includes(screen) ? "small" : "middle"}
              onClick={() => {
                setVisible(true);
              }}
              danger
            >
              End Session
            </Button>
            <Button
              size={["xs", "sm"].includes(screen) ? "small" : "middle"}
              type="primary"
              onClick={() => {
                callClaimAPI();
                resetStateHandler();
                setSkippedQuestionsToday(false);
              }}
            >
              Next
            </Button>
          </Space>
        ) : null}
        {isQuestionSessionStarted ? (
          <>
            {isQuestionSessionStarted &&
              !isNext &&
              !isSkipped &&
              status !== "REOPENED" && (
                <>
                  {status === "SKIPPED" && !isSkipped ? (
                    <Button
                      onClick={() => {
                        setSkipModalVisible(true);
                      }}
                      style={{ marginRight: 8 }}
                    >
                      Reject
                    </Button>
                  ) : (
                    <Button
                      danger
                      onClick={() => {
                        if (questionSkipCount >= maxQuestionSkipCount) {
                          message.error(
                            `This question has reached its maximum skip limit of ${maxQuestionSkipCount}. You cannot skip this question.`
                          );
                        } else {
                          setSkipModalVisible(true);
                        }
                      }}
                      style={{ marginRight: 8 }}
                      disabled={
                        facultyDailySkipCount >= maxFacultyDailySkipCount
                      }
                    >
                      Skip Question ({facultyDailySkipCount}/
                      {maxFacultyDailySkipCount})
                    </Button>
                  )}
                </>
              )}
            {!isNext && !skippedQuestionsToday && !isSkipped && (
              <Button
                size={["xs", "sm", "md"].includes(screen) ? "small" : "middle"}
                type="primary"
                onClick={onSave}
                htmlType="submit"
                loading={isSubmitting || isUploading}
                disabled={
                  isSubmitting ||
                  (isQuestionSessionStarted ? isDisabled || isUploading : false)
                }
                style={{
                  width: ["xs", "sm", "md"].includes(screen) ? "100%" : "auto",
                }}
              >
                {!isQuestionSessionStarted ? "Start" : "Submit"}
              </Button>
            )}
            {isSkipped && (
              <Button
                type="primary"
                onClick={() => {
                  callClaimAPI();
                  resetStateHandler();
                  setIsSkipped(false);
                }}
              >
                Next
              </Button>
            )}
          </>
        ) : (
          <Button
            size={["xs", "sm", "md"].includes(screen) ? "small" : "middle"}
            type="primary"
            onClick={onSave}
            htmlType="submit"
            loading={isSubmitting || isUploading}
            disabled={
              isSubmitting ||
              (isQuestionSessionStarted ? isDisabled || isUploading : false)
            }
            style={{
              width: ["xs", "sm", "md"].includes(screen) ? "100%" : "auto",
            }}
          >
            {!isQuestionSessionStarted ? "Start" : "Submit"}
          </Button>
        )}
      </Space>
    </div>
  );
};

export default DRSFooter;
